import QueryContext from '@/api/QueryContext';
import api from '../index';

const campaignV2CreatorsFetchers = {
  list: (context: QueryContext) =>
    api.get(`/campaigns/${context.meta?.campaignId}/creators`, {
      params: {
        'status': context.meta?.status,
        'page': context.meta?.page,
        'per_page': context.meta?.perPage,
        'search': context.meta?.search || undefined,
        'filter[shortlisted]':
          context.meta?.shortlisted !== undefined
            ? context.meta.shortlisted
            : undefined,
        'filter[has_unread_messages]':
          context.meta?.hasUnreadMessages !== undefined
            ? context.meta.hasUnreadMessages
            : undefined,
      },
    }),
  counts: (context: QueryContext) =>
    api.get(`/campaigns/${context.meta?.campaignId}/creators/counts`),
};

export default campaignV2CreatorsFetchers;
